import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        resources: {
            en: {
                translation: {
                    'paper-reading-title': 'Paper Studying',
                    'reader-title': 'Oracle Reader',
                    'trends-review-title': 'Trends & Reviews',
                    'paper-translator-title': 'Paper Translator',
                    'paper-reading-description': 'Paper reading description',
                    'trends-review-description': 'Trends and survey description',
                    'paper-translator-description': 'Paper translator description',
                    'summarizer-title': 'Doenba Summarizer',
                    'reviewer-title': 'Doenba Reviewer',
                    'taskqa-title': 'Task-oriented QA',
                    'translator-title': 'Paper Translator',
                    'summarizer-description': 'Doenba Summarizer produces a summary of an article or a topic within it, crafted as if written by a domain expert, tailored to user specifications',
                    'reviewer-description': 'Doenba Reviewer generates a hierarchically organized overview report from a large number of relevant articles.',
                    'taskqa-description': 'Doenba Task-Oriented QA enables users to ask any question about a paper or a collection of papers, whether specific to a topic or encompassing the entire content. Uwers can inquire about methods used, major results and findings, and case studies, and receive accurate and succinct answers.',
                    'translator-description': 'Doenba Paper Translator enables users to translate a paper written in their native language to English and vice versa while preserving the same text format.',
                    'explore-btn': 'Explore',
                    'my-library-title': 'My Library',
                    'my-library-drag-drop-description': 'Click to select or drag & drop PDF files.',
                    'select-a-file': 'Click to upload or drag PDF or CSV file here.',
                    'file-selected': 'File selected',
                    'file-format-label': 'It supports very long articles in the',
                    'upload-label': 'Upload article',
                    'search-placeholder': 'Search articles ...',
                    'mini-nav-taskrqa': 'Read',
                    'mini-nav-taskrqa-description': 'Task Oriented Reading & QA',
                    'mini-nav-read-analyze': 'Read & Analyze',
                    'mini-nav-read-analyze-description': 'Reading, QA & data analysis',
                    'mini-nav-tasksearch': 'Task Search',
                    'mini-nav-tasksearch-description': 'Task Search',
                    'mini-nav-notes':'Notes',
                    'mini-nav-notes-description':'Add and edit notes',
                    'mini-nav-editor':'Edit',
                    'mini-nav-review':'Review',
                    'mini-nav-review-description': 'Rubric-based paper reviewing',
                    'mini-nav-paper-review':'Paper Review',
                    'create-paper': 'Start a new document',
                    'search-tip': 'Search Document or Template',
                    'create-text': 'Create',
                    'recent-paper': 'Recent Documents',
                    'modify-text': 'Last Modified',
                    'open-create-text': 'Date Created',
                    'title-sort': 'Title',
                    'mini-nav-editor-description':'AI-powered editing tool',
                    'quick-uploader-full-label': 'Click to upload or drag PDF or CSV file here',
                    'quick-uploader-short-label': 'File uploader',
                    'oracle-reader-label': 'Enter a topic and press return to search for its contents.',
                    'my-plan-label': 'My Plan',
                    'my-profile-label': 'Profile',
                    'my-Upgrade Plan': 'Subscription',
                    'my-export-history': 'Export History',
                    'global-getting-article-label': 'Getting your article ready at the moment.',
                    'study-sessions-label': 'Study sessions',
                    'all-study-sessions-label': 'All sessions',
                    'custom-summary-label': 'Custom summary',
                    'start-to-chat-label': 'Start',
                    'created-on-label': 'Created on',
                    'updated-at-label': 'Updated at',
                    'preview-label': 'Preview',
                    'download-label': 'Download',
                    'mini-nav-about-label': 'About',
                    'cut-label': 'Cut',
                    'remove-label': 'Remove',
                    'retry-indicator-label': 'RETRY',
                    'failure-indicator-label': 'UNSUPPORTED FILE ISSUES',
                    'in-progress-indicator-label': 'IN PROCESSING',
                    'action-label': 'Actions',
                    'article-title-label': 'Article Name',
                    'login-label': 'Login',
                    'logout-label': 'Logout',
                    'signup-label': 'Sign up',
                    'cancel-label': 'Cancel',
                    'is-cut-label': 'is cut',
                    'cancel-paste-label': 'Cancel paste',
                    'paste-here-label': 'Paste here',
                    'paste-successful-label': 'has been pasted successfully',
                    'logout-confirmation': 'Are you sure you want to sign out?',
                    'enable-inspiration-label': 'Enable Inspiration?',
                    'get-answer-label': 'Would you like to get the answer?',
                    'yes-label': 'Yes',
                    'no-label': 'No',
                    'export-text': 'Export to LateX',
                    'supports-both-highlights': "Supports Topic Highlight and Task RQA Highlight",
                    'supports-topic-highlight': "Supports Topic Highlight",
                    'supports-task-rqa-highlight': "Supports Task RQA Highlight",
                    'supports-task-rqa': "Supports Task RQA",
                    'supports-custom-summary': "Supports Custom Summary",
                    'supports-figures': "Supports Figures",
                    'supports-tables': "Supports Tables",
                    'supports-equations': "Supports Equations",
                    'from-doenba-inspiration': "(Suggested by Doenba)",
                    'doenba-intro': 'Once upon a time, there was a Tibetan teacher named <b>Doenba</b> who had the remarkable ability to serve as the original author for any article, faithfully explaining its contents and providing inspirational suggestions. Our system replicates and expands upon Doenba\'s capabilities; hence, we have named it <b>Doenba</b>.',
                    'learn-more-btn': 'Learn More',
                    'get-started-label': 'Get started',
                    'terms-of-use-label': 'Terms of Use',
                    'privacy-policy-label': 'Privacy Policy',
                    'title1': 'Reveal Authors\' Insights: Deep thoughts within reach.',
                    'title2': 'Summarize Smarter: Tailored to Meet Your Needs.',
                    'title3': 'Explore with AI: Your Questions, Your Interests, Appropriately Answered.',
                    'title4': 'Get Answers That Matter: No Hallucinations, No Distractions, No More Waste of Time.',
                    'description1': 'Discover the gateway to streamlined research, navigating through complex information and deep knowledge with ease.',
                    'description2': 'Experience the cutting-edge of summarization technology, delivering succinct and precise summaries tailored to your needs.',
                    'description3': 'Dive deeper into your interests with an AI-powered search function, connecting you with articles relevant to your interests.',
                    'description4': 'Engage with our specialized QA system, crafted to provide accurate answers by analyzing contents, ensuring that you receive informed responses to your inquiries.',
                    'identified-article-label': 'We have identified the same article in your library collection.',
                    'accept-label': 'Accept this article',
                    'continue-uploading-label': 'Upload as new',
                    'zoom-in': 'Zoom in',
                    'zoom-out': 'Zoom out',
                    "clear-highlights": "Clear highlights",
                    'focus-mode': 'Focus mode',
                    'remove-from': 'Remove from',
                    'add-to': 'Add to',
                    'my-reading-list': 'My reading list',
                    'my-reading-list-postfix': 'my reading list',
                    'shared-list': 'Shared',
                    'math-explaination': 'Math f(x) explaination',
                    'support-center': 'Support center',
                    'get-summary-label': 'Get summary for this article',
                    'all-qa-tooltip': 'Initially, only the QA sessions related to the chosen article are visible. However, by enabling this feature, all sessions will become accessible.',
                    'generating-summary-label': 'Generating summary now.',
                    'middle-school': 'Middle school',
                    'high-school': 'High school',
                    'college': 'College',
                    'expert': 'Expert',
                    'others': 'Others',
                    'level': 'Level',
                    'words': 'words',
                    'generate-summary': 'Generate summary',
                    'summary-lang-label': 'English',
                    'rename': 'Rename',
                    'download': 'Download',
                    'delete': 'Delete',
                    'copy': 'Copy',
                    'highlight': 'Highlight',
                    'clear-highlight': 'Clear highlights',
                    'add-notes': 'Add to notes',
                    'coming-soon': 'coming soon',
                    'success-label': 'Success',
                    'failed-label': 'Failed',
                    'copy-successful': 'Copy successful',
                    'copy-failed': 'Copy failed',
                    'inspiration-message': 'Turning on the inspiration feature, Doenba will generate insightful suggestions based on your recent inquiries and the content of the article to encourage deeper and broader thinking.',
                    'enter-msg-here': 'Enter your questions here ...',
                    'no-conversation-history': 'No history of conversation exists',
                    'search-articles-here': 'Search articles here ...',
                    'remove-article-label': 'Remove artilce from reading list',
                    'no-article-been-added': 'No article been added.',
                    'processing-indicator-tooltip-label': 'The processing is in session for using Task RQA. We appreciate your patience.',
                    'processing-indicator-error': 'The system is currently busy. Please try again later.',
                    'open': 'Open',
                    'start-label': 'Start',
                    'read-later': 'Read later',
                    'is-ready-postfix': 'is ready',
                    'video-title-rqa': 'Introduction',
                    'video-title-inspiration': 'Inspiration mode',
                    'video-title-tables-formulas': 'Table and formulas analysis',
                    'video-title-organization': 'Data management',
                    'video-title-undergrad-math_demo': 'Undergrad Math Demo',
                    'demo-videos': 'Demo videos',
                    'topic-highlighting': 'Topic highlighting',
                    'highlighting-context': 'Highlights for related context',
                    'custom-summary-description': '',
                    'rqa-description': '',
                    'topic-highlighting-description': '',
                    'highlighting-context-description': '',
                    'inspiration-description': '',
                    'choose-existing-article': 'Choose existing article',
                    'case-study-label': 'Case study',
                    'in-action-label': 'Doenba.ai in Action',
                    'features-label': 'Features',
                    'delete-conversation-label': 'Delete this message',
                    'conversation-deleting-confirmation-message': 'Are you sure you want to delete this message from the conversation?',
                    'confirm-label': 'Confirmed',
                    'message-deleting-label': 'Deleting this message?',
                    'more-options-label': 'More options',
                    'quotation-label': 'Quote',
                    'editor-previewmodel-selectlabeltip':'Once you select the template, we will sync the structure to your writing',
                    'editor-previewmodel-selectbtnlabel':'select',
                    'editor-previewmodel-switchBtnTip':'there is no more template',
                    'editor-editormodel-leftHeader':'Reference Article',
                    'editor-editormodel-leftHeaderRefOutline':'Structure',
                    'editor-editormodel-leftHeaderRefTone':'Tone',
                    'editor-editormodel-leftUploadRef':'Upload  to replace your reference article. We will analyze it with you to merge from your reference about the structure.',
                    'editor-editormodel-leftDeleteRef':'Are you sure you want to delete this {0}?',
                    'editor-editormodel-leftDeletePanel1':'Are you sure you want to delete ',
                    'editor-editormodel-leftDeletePanel2':' in your structure?',
                    'editor-editormodel-leftDeletePanel3':'The content under this section belongs to the Body.',
                    'editor-editormodel-leftBtnCancel':'Cancel',
                    'editor-editormodel-leftBtnDelete':'Delete',
                    'editor-editormodel-leftBtnConfirm':'Confirm',
                    'editor-editormodel-leftBtnSelect':'Select',
                    'editor-editormodel-leftBtnApply':'Apply',
                    'editor-editormodel-leftTipUpload':'Drag to Upload',
                    'editor-editormodel-leftTipUploadFile':' Please upload pdf. words. txt. files',
                    'editor-editormodel-leftOverview':'Overview',
                    'editor-editormodel-leftStyle':'Style',
                    'editor-editormodel-leftExport':'Export',
                    'editor-editormodel-leftTutorial':'Tutorial',
                    'editor-editormodel-leftHelp':'Help',
                    'editor-editormodel-treeAdd':'Add New',
                    'editor-editormodel-treeRename':'Rename',
                    'editor-editormodel-treeDelete':'Delete',
                    'editor-editormodel-treeInputCancel':'Cancel',
                    'editor-editormodel-treeInputSave':'Save',
                    'editor-editormodel-noSectionTip1':`Doenba Edit is a comprehensive AI-powered editing platform designed to streamline your writing process.
Work within an organized interface with a word-processor-style experience, featuring automatic LaTeX conversion—no coding required—and an intuitive graphical interface for managing cross-references and citations. Enjoy one-click export to various LaTeX templates for download and PDF preview.
Take full advantage of LaTeX by writing your own snippets with real-time PDF previews.
Boost your productivity with suggested outlines, text polishing and rephrasing, content review, and exposition restructuring.
Leverage the built-in question-answering system for real-time assistance throughout the writing process.`,
                    'editor-editormodel-noSectionTip2.1':'Click',
                    'editor-editormodel-noSectionTip2.2':'to begin writing.',
                    'editor-editormodel-midNewSubsection2':'Heading2',
                    'editor-editormodel-midNewSubsection3':'Heading3',
                    'editor-editormodel-midNewSubsection4':'Heading4',
                    'editor-editormodel-midNewSubsection5':'Heading5',
                    'editor-editormodel-midNewSubsection6':'Heading6',
                    'editor-editormodel-midNewParagraph':'Paragraph',
                    'editor-editormodel-Text':'Text',
                    'editor-editormodel-midNewTable':'Table',
                    'editor-editormodel-phraseBtn':'Rephrase selected content',
                    'editor-editormodel-Rephrasing':'Rephrasing selected content',
                    'editor-editormodel-Refineing':'Refining selected content',
                    'editor-editormodel-copytext':'Text copied to clipboard!',
                    'editor-editormodel-AI-Rephrase':'Rephrase',
                    'editor-editormodel-AI-RephraseLength-0':'Shotest',
                    'editor-editormodel-AI-RephraseLength-1':'Shoter',
                    'editor-editormodel-AI-RephraseLength-2':'Current Length',
                    'editor-editormodel-AI-RephraseLength-3':'Longer',
                    'editor-editormodel-AI-RephraseLength-4':'Longest',
                    'editor-editormodel-AI-Rephrasedegree-0':'High School',
                    'editor-editormodel-AI-Rephrasedegree-1':'Undergraduate',
                    'editor-editormodel-AI-Rephrasedegree-2':'Current level',
                    'editor-editormodel-AI-Rephrasedegree-3':'Graduate',
                    'editor-editormodel-AI-Rephrasedegree-4':'Doctoral',
                    'editor-editormodel-AI-Suggestions':'Review',
                    'editor-editormodel-AI-Review':'Review',
                    'editor-editormodel-AI-SuggestionsCalculate':'Checking for content coherence and completeness',
                    'editor-editormodel-AI-SuggestionsContents':' Suggestions',
                    'editor-editormodel-AI-SuggestionsTip':'Click review to get Suggestions',
                    'editor-editormodel-AI-Suggestion-Check':'Check',
                    'editor-editormodel-AI-Suggestion-Checking':'Checking Your Revise',
                    'editor-editormodel-AI-Suggestion-Check-Ok':'Awesome! That’s a solid improvement!',
                    'editor-editormodel-AI-Suggestion-Ignore':'Ignore',
                    'editor-editormodel-AI-SuggestionDegree-0':'  High School',
                    'editor-editormodel-AI-SuggestionDegree-1':'  Undergraduate',
                    'editor-editormodel-AI-SuggestionDegree-2':'  Current',
                    'editor-editormodel-AI-SuggestionDegree-3':'  Graduate',
                    'editor-editormodel-AI-SuggestionDegree-4':'  Doctoral',
                    'editor-editormodel-AI-Reorganize':'Reorganize',
                    'editor-editormodel-AI-Refine':'Refine',
                    'editor-editormodel-AI-Generation':'Automation',
                    'editor-editormodel-AI-Summary':'Summary',
                    'editor-editormodel-AI-Abstract':'Abstract',
                    'editor-editormodel-AI-Conclusion':'Conclusion',
                    'editor-editormodel-rightLibrary':'Resources Library',
                    'editor-editormodel-rightLibraryRemove':'Remove',
                    'editor-editormodel-rightLibraryCite':'Cite',
                    'editor-editormodel-rightLibraryAdd':'Add',
                    'editor-editormodel-reorganize-replace':'Replace',
                    'cannot-insert-block-element': 'Cannot insert block element',
                    'cannot-insert-block-element-description': 'Block element cannot be inserted in the first level title. Please move the cursor to the main body area',
                    'editor-editormodel-reorganize-rewrite':'Rewrite',
                    'editor-editormodel-reorganize-loading':'Exploring how reorganization could improve your draft.',
                    'save-loading-text': 'saving...',
                    'save-completed-text': 'save completed',
                    'file-uploading-text': 'File Uploading',
                    'file-processing-text': 'File Processing',
                    'upload-draft-tip': 'Please upload a draft',
                    'ai-chat-placeholder': 'Message Doenba',
                    'import-draft-tip': 'Import an Existing Draft',
                    'pricing-plan-desc-1': 'Start with your preferred outline',
                    'pricing-plan-desc-2': 'AI-powered content editing and typesetting',
                    'pricing-plan-desc-3': 'Integrated Q&A chatbot',
                    'pricing-plan-desc-4': 'Word processor-style interface',
                    'pricing-plan-desc-5': 'Easily insert figures, tables, equations, cross-references, and citations',
                    'pricing-plan-desc-6': 'LaTeX snippets with real-time section previews',
                    'pricing-plan-desc-7': 'One-click export to supported LaTeX templates',
                    'free-plan-title': 'Free',
                    'free-plan-subtitle': 'Read & Analyze + Review',
                    'free-plan-desc-1': 'Upload and read PDF and CSV documents',
                    'free-plan-desc-2': 'AI-powered document analysis, including dissection, summarization, data processing, and code generation',
                    'free-plan-desc-3': 'Interactive task Q&A chatbot for uploaded documents',
                    'free-plan-desc-4': 'AI-powered precision reading',
                    'free-plan-desc-5': 'AI-powered inspirational suggestions to enhance comprehension',
                    'free-plan-desc-6': 'AI-powered paper review and feedback',
                    'pro-plan-subtitle': 'Edit + Read & Analyze + Review',
                    'ai-send-waiting-text': "I'm working on it ...",
                    // FAQ entries
                    'faq-question-1': 'What is Doenba Edit?',
                    'faq-answer-1': 'Doenba Edit is an AI-powered academic writing and editing platform developed by Librum Technologies Inc. It combines real-time editing, LaTeX/Markdown/Word compatibility, version tracking, and AI-assisted polishing into one integrated workspace for students, researchers, and educators.',
                    'faq-question-2': 'Do I need to install anything to use Doenba Edit?',
                    'faq-answer-2': 'No installation is needed. Doenba Edit runs entirely in your browser. Simply sign up and log in to start writing and compiling online.',
                    'faq-question-3': 'Can I use Doenba Edit without signing up?',
                    'faq-answer-3': 'To create or edit documents, you need an account. On the Doenba homepage, select "Sign up" to create your account.',
                    'faq-question-4': 'Is Doenba Edit free? What are the paid plans?',
                    'faq-answer-4': 'We offer a **7-day free trial** for all new users. After the trial, you can choose from three paid plans — weekly, monthly, or annual. Each plan includes the same set of features; the only difference is the subscription length.\n\nOnce you\'re signed in, click your profile picture in the upper-right corner and select "Subscription." From there, you can start your 7-day free trial and later choose the plan that best fits your needs.',
                    'faq-question-5': 'How do I create a new article?',
                    'faq-answer-5': 'From the dashboard, click "Create." On the next page, enter your article title, then build an outline using the panel on the left. You have three ways to create it:\n\n- **Use a Default Outline** — a subject-based template provided by the system.\n- **Extract an Outline** from an article you upload.\n- **Create an Outline from Scratch** to fully customize your structure.\n\nOnce your outline is ready, you can begin writing your article section by section.',
                    'faq-question-6': 'How does saving work in Doenba Edit?',
                    'faq-answer-6': 'All changes are **auto-saved** as you type. Each edit is stored in the cloud and linked to your account. You can download a PDF or LaTeX source at any time.',
                    'faq-question-7': 'How does the AI assistant help me?',
                    'faq-answer-7': 'The AI assistant can polish your writing, rewrite sentences by meaning, suggest structures, generate outlines, fix formatting, and check references. Each action is coordinated through Doenba\'s AI technology to ensure accuracy and traceability.',
                    'faq-question-8': 'What happens if I cancel my subscription?',
                    'faq-answer-8': 'If you cancel your subscription:\n\n- **Your data is safe**: All of your work and articles remain securely stored.\n- **Access is paused**: You won\'t be able to view or edit your articles until you resubscribe.\n- **Easy reactivation**: Resubscribe anytime to instantly restore full access to your account and saved content.',
                    'faq-question-9': 'How is my data stored and protected?',
                    'faq-answer-9': 'Documents are **encrypted** and stored securely on Librum cloud servers. Data transfers use **SSL encryption**, and private projects are accessible only to authorized users.',
                    'faq-question-10': 'How can I recover a previous version of my article?',
                    'faq-answer-10': 'In your document, go to "**Version History**" in the upper right corner to access all the saved versions. You can preview, compare, and restore any previous version.',
                    'faq-question-11': 'How can I get more help or contact support?',
                    'faq-answer-11': 'Visit the **Help Center/FAQ** page, or watch our video tutorials (located in the lower left corner of the article editing page). You can also use the Help Center on the right to send us your question and contact information. We\'ll follow up with support via email.',
                    'repeat-label': 'Label is ready taken',
                    'suggestion-all-ok': 'Impressive! <br/> You’ve made it shine!',
                    'toolbox-bold': 'Bold',
                    'toolbox-italic': 'Italic',
                    'toolbox-underline': 'Underline',
                    'toolbox-image': 'Figure',
                    'toolbox-table': 'Table',
                    'toolbox-footnote': 'FootNote',
                    'toolbox-preview': 'Preview',
                    'toolbox-math': 'Equation',
                    'import': 'Import',
                    'outline-text': 'Default Outline',
                    'authors': 'Author Info',
                    'outline-tooltip': 'Select an outline which you can modify or create your own as you write.',
                    'default': 'Default Outline',
                    'extract': 'Extract Outline',
                    'paper-edit-menu': 'Edit',
                    'paper-view-menu': 'View',
                    'paper-del-menu': 'Delete',
                    'delete-paper-title': 'Delete this paper',
                    'delete-paper-tip': 'Do you really want to delete this paper?',
                    'modal-close': 'Close'
                }
            },
            cn: {
                translation: {
                    'paper-reading-title': 'Paper Studying',
                    'reader-title': 'Oracle Reader',
                    'trends-review-title': 'Trends & Reviews',
                    'paper-translator-title': 'Paper Translator',
                    'paper-reading-description': 'Paper reading description',
                    'trends-review-description': 'Trends and survey description',
                    'paper-translator-description': 'Paper translator description',
                    'summarizer-title': 'Doenba Summarizer',
                    'reviewer-title': 'Doenba Reviewer',
                    'taskqa-title': '任务导向问答 (Task-oriented QA)',
                    'translator-title': '论文翻译工具 (Paper Translator)',
                    'summarizer-description': 'Doenba Summarizer 根据用户定制的字数及其他要求，对文章或其中一个话题生成仿佛有领域专家撰写的精准摘要。',
                    'reviewer-description': 'Doenba Reviewer从大量相关文章中生成一个层次化组织的概述报告。',
                    'taskqa-description': 'Doenba任务导向问答（QA）允许用户提出关于一篇论文或一系列论文的任何问题，无论是特定于某一话题还是涵盖整个内容。比如询问所使用的方法、主要结果和发现以及案例研究，并获得准确而简洁的答案。',
                    'translator-description': 'Doenba论文翻译工具允许用户将他们的母语撰写的论文翻译成英文，反之亦然，同时保留相同的文本格式。',
                    'explore-btn': '使用',
                    'my-library-title': '我的文库',
                    'my-library-drag-drop-description': '点击选择或拖拽上传PDF文档。',
                    'select-a-file': '点击选择或拖拽上传PDF文档或CSV文档。',
                    'file-selected': '已上传的文档',
                    'file-format-label': '支持长文上传，格式包括：',
                    'upload-label': '上传',
                    'search-placeholder': '搜索文章 ...',
                    'mini-nav-taskrqa': '解读助手',
                    'mini-nav-taskrqa-description': '任务导向阅读与问答',
                    'mini-nav-read-analyze': '阅读与分析',
                    'mini-nav-read-analyze-description': '阅读、问答与数据分析',
                    'mini-nav-tasksearch': '任务导向搜索',
                    'mini-nav-tasksearch-description': '任务导向搜索',
                    'mini-nav-notes':'Notes',
                    'mini-nav-notes-description':'Add and edit notes',
                    'mini-nav-editor':'写作助手',
                    'mini-nav-review':'Review',
                    'mini-nav-review-description': '基于评分标准的论文评审',
                    'mini-nav-paper-review':'Paper Review',
                    'search-tip': '文库查询',
                    'create-text': '新建',
                    'recent-paper': '文库（按新到旧排列）',
                    'modify-text': '更新日期',
                    'open-create-text': '创建日期',
                    'title-sort': '标题',
                    'create-paper': '新建文章',
                    'mini-nav-editor-description':'AI写作助手',
                    'quick-uploader-full-label': '点击选择或拖拽上传PDF文档或CSV文档',
                    'quick-uploader-short-label': '文档上传',
                    'oracle-reader-label': '给定一个主题，（敲击回车键）搜索相关内容',
                    'my-plan-label': '我的订阅',
                    'my-profile-label': '个人资料',
                    'my-Upgrade Plan': '我的套餐',
                    'my-export-history': '导出记录',
                    'global-getting-article-label': '正在导入文章',
                    'study-sessions-label': '问答单元',
                    'all-study-sessions-label': '全部问答单元',
                    'custom-summary-label': '定制摘要',
                    'start-to-chat-label': '开始',
                    'created-on-label': '上传日期',
                    'updated-at-label': '修改日期',
                    'preview-label': '预览',
                    'download-label': '下载',
                    'cut-label': '剪切',
                    'remove-label': '删除',
                    'retry-indicator-label': '重试',
                    'failure-indicator-label': '格式出现问题',
                    'in-progress-indicator-label': '文章正在处理',
                    'action-label': '选项',
                    'article-title-label': '文章名字',
                    'login-label': '登入',
                    'logout-label': '登出',
                    'signup-label': '注册',
                    'cancel-label': '取消',
                    'is-cut-label': '粘贴中',
                    'cancel-paste-label': '取消粘贴',
                    'paste-here-label': '粘贴于此',
                    'paste-successful-label': '被粘贴成功',
                    'logout-confirmation': '您确定是要退出登录么？',
                    'enable-inspiration-label': '开启启发模式？',
                    'get-answer-label': '您想问这个问题么?',
                    'yes-label': '是的',
                    'no-label': '不用',
                    'export-text': '导出LaTeX',
                    "supports-both-highlights": "支持主题高亮和任务 RQA 高亮",
                    "supports-topic-highlight": "支持主题高亮",
                    "supports-task-rqa-highlight": "支持任务 RQA 高亮",
                    "supports-task-rqa": "支持任务 RQA",
                    "supports-custom-summary": "支持自定义摘要",
                    "supports-figures": "支持图表解析",
                    "supports-tables": "支持表格解析",
                    "supports-equations": "支持方程解析",
                    "from-doenba-inspiration": "（Doenba 提议）",
                    'doenba-intro': '<b>Doenba</b> 是很久以前的一名西藏智者，能力超凡，对任何从未读过的文章都能迅速和完整地理解其内容，并以原作者的角色忠实地解答关于文章内容的任意提问和提供启发式建议。我们的系统复制并扩展了<b>Doenba</b>的能力，故取名为<b>Doenba</b>。',
                    'learn-more-btn': '了解更多',
                    'get-started-label': '开始使用',
                    'terms-of-use-label': '使用条款',
                    'privacy-policy-label': '用户隐私',
                    'title1': '揭示作者的洞察：深入思考触手可及。',
                    'title2': '更智能的总结：量身定制以满足您的需求。',
                    'title3': '与AI一起探索：您的问题，您的兴趣，得到恰当的回答。',
                    'title4': '获得重要的答案：没有幻觉，没有干扰，不再浪费时间。',
                    'description1': '发现顺畅研究的入口，轻松导航复杂信息和深入知识。',
                    'description2': '体验总结技术的前沿，提供简洁准确的总结，量身定制以满足您的需求。',
                    'description3': '通过AI驱动的搜索功能深入探索您的兴趣，连接您与与您兴趣相关的文章。',
                    'description4': '与我们专门的问答系统互动，该系统旨在通过分析内容提供准确的答案，确保您对询问获得知情的回应。',
                    'identified-article-label': '在您的文库中找到了之前上传相同的文章，请核实：',
                    'accept-label': '确认是这篇文章',
                    'continue-uploading-label': '作为新文章上传',
                    "zoom-in": "放大",
                    "zoom-out": "缩小",
                    "clear-highlights": "清空所有高亮",
                    "focus-mode": "聚焦模式",
                    "remove-from": "移除",
                    "add-to": "添加",
                    "my-reading-list": "阅读列表",
                    "my-reading-list-postfix": "我的阅读列表",
                    'shared-list': '共享',
                    "math-explaination": "数学公式解析",
                    "support-center": "支持中心",
                    "get-summary-label": "获取本文摘要",
                    "all-qa-tooltip": "初始时，只显示与选定文章相关的问答单元。但启用此功能后，将可以访问所有会话。",
                    "generating-summary-label": "正在生成摘要。",
                    "middle-school": "初中",
                    "high-school": "高中",
                    "college": "大学",
                    "expert": "专家",
                    "others": "其他",
                    "level": "水平",
                    "words": '字数',
                    'generate-summary': '生成摘要',
                    'summary-lang-label': '中文',
                    'rename': '重命名',
                    'download': '下载',
                    'delete': '删除',
                    'copy': '复制',
                    "highlight": "高亮",
                    "clear-highlight": "清除高亮",
                    "add-notes": "添加到笔记",
                    "coming-soon": "即将推出",
                    'success-label': '成功',
                    'failed-label': '失败',
                    'copy-successful': '复制成功',
                    'copy-failed': '复制失败',
                    "inspiration-message": "开启灵感功能，Doenba 将根据您最近的查询和文章内容生成富有洞察力的建议，以鼓励更深入、更广泛的思考。",
                    'enter-msg-here': '请在此输入您的问题',
                    'no-conversation-history': '没有会话记录',
                    'search-articles-here': '在此搜索文章 ...',
                    'remove-article-label': '从阅读列表中移除文章',
                    'no-article-been-added': '还没有添加文章',
                    "processing-indicator-tooltip-label": "任务 RQA 处理中。感谢您的耐心等待。",
                    "processing-indicator-error": "系统当前繁忙。请稍后再试。",
                    'open': '打开',
                    'read-later': '稍后阅读',
                    'is-ready-postfix': '准备就绪',
                    "video-title-rqa": "简介",
                    "video-title-inspiration": "启发模式",
                    "video-title-tables-formulas": "表格和公式解析",
                    "video-title-organization": "资料管理",
                    'video-title-undergrad-math_demo': '本科数学演示',
                    'demo-videos': '视频演示',
                    'topic-highlighting': '主题问答高亮',
                    'highlighting-context': '问答相关原文高亮',
                    'custom-summary-description': '',
                    'rqa-description': '',
                    'topic-highlighting-description': '',
                    'highlighting-context-description': '',
                    'inspiration-description': '',
                    'choose-existing-article': '选择现有文章',
                    'case-study-label': '案例展示',
                    'in-action-label': 'Doenba.ai 助力学习',
                    'features-label': '特别功能',
                    'delete-conversation-label': '删除该对话',
                    'conversation-deleting-confirmation-message': '您确定要删除此对话消息吗？',
                    'confirm-label': '确认',
                    'message-deleting-label': '对话删除?',
                    'more-options-label': '更多选项',
                    'quotation-label': '引用',
                    'editor-previewmodel-selectlabeltip':'Once you select the template, we will sync the structure to your writing',
                    'editor-previewmodel-selectbtnlabel':'选择模板',
                    'editor-previewmodel-switchBtnTip':'没有更多模板',
                    'editor-editormodel-leftHeader':'Reference Article',
                    'editor-editormodel-leftHeaderRefOutline':'Structure',
                    'editor-editormodel-leftHeaderRefTone':'Tone',
                    'editor-editormodel-leftDeleteRef':'Are you sure you want to delete this {0}?',
                    'editor-editormodel-leftDeletePanel1':'Are you sure you want to delete',
                    'editor-editormodel-leftDeletePanel2':'in your structure?',
                    'editor-editormodel-leftDeletePanel3':'The content under this section belongs to the Body.',
                    'editor-editormodel-leftBtnCancel':'Cancel',
                    'editor-editormodel-leftBtnDelete':'delete',
                    'editor-editormodel-leftBtnConfirm':'Confirm',
                    'editor-editormodel-leftBtnSelect':'Select',
                    'editor-editormodel-leftBtnApply':'apply',
                    'editor-editormodel-leftTipUpload':'Drag to Upload',
                    'editor-editormodel-leftTipUploadFile':' Please upload pdf. words. txt. files',
                    'editor-editormodel-leftOverview':'Overview',
                    'editor-editormodel-leftStyle':'Style',
                    'editor-editormodel-leftExport':'导出',
                    'editor-editormodel-leftTutorial':'指南',
                    'editor-editormodel-leftHelp':'帮助',
                    'editor-editormodel-treeAdd':'Add New',
                    'editor-editormodel-treeRename':'Rename',
                    'editor-editormodel-treeDelete':'Delete',
                    'editor-editormodel-treeInputCancel':'Cancel',
                    'editor-editormodel-treeInputSave':'Save',
                    'editor-editormodel-noSectionTip1':`Doenba Edit is a comprehensive AI-powered editing platform designed to streamline your writing process.
Work within an organized interface with a word-processor-style experience, featuring automatic LaTeX conversion—no coding required—and an intuitive graphical interface for managing cross-references and citations. Enjoy one-click export to various LaTeX templates for download and PDF preview.
Take full advantage of LaTeX by writing your own snippets with real-time PDF previews.
Boost your productivity with suggested outlines, text polishing and rephrasing, content review, and exposition restructuring.
Leverage the built-in question-answering system for real-time assistance throughout the writing process.`,
                    'editor-editormodel-noSectionTip2.1':'Click',
                    'editor-editormodel-noSectionTip2.2':'to begin writing.',
                    'editor-editormodel-midNewSubsection2':'Heading2',
                    'editor-editormodel-midNewSubsection3':'Heading3',
                    'editor-editormodel-midNewSubsection4':'Heading4',
                    'editor-editormodel-midNewSubsection5':'Heading5',
                    'editor-editormodel-midNewSubsection6':'Heading6',
                    'editor-editormodel-midNewParagraph':'Paragraph',
                    'editor-editormodel-Text':'Text',
                    'editor-editormodel-midNewTable':'Table',
                    'editor-editormodel-phraseBtn':'Rephrase selected content',
                    'editor-editormodel-AI-RephraseLength-0':'Shotest',
                    'editor-editormodel-AI-RephraseLength-1':'Shoter',
                    'editor-editormodel-AI-RephraseLength-2':'Current Length',
                    'editor-editormodel-AI-RephraseLength-3':'Longer',
                    'editor-editormodel-AI-RephraseLength-4':'Longest',
                    'editor-editormodel-AI-Rephrasedegree-0':'High School',
                    'editor-editormodel-AI-Rephrasedegree-1':'Undergraduate',
                    'editor-editormodel-AI-Rephrasedegree-2':'Current level',
                    'editor-editormodel-AI-Rephrasedegree-3':'Graduate',
                    'editor-editormodel-AI-Rephrasedegree-4':'Doctoral',
                    'editor-editormodel-AI-Suggestions':'Review',
                    'editor-editormodel-AI-Review':'Review',
                    'editor-editormodel-AI-SuggestionsCalculate':'Checking for content coherence and completenessn',
                    'editor-editormodel-AI-SuggestionsContents':' Suggestions',
                    'editor-editormodel-AI-SuggestionsTip':'Click review to get Suggestions',
                    'editor-editormodel-AI-Suggestion-Check':'Check',
                    'editor-editormodel-AI-Suggestion-Ignore':'Ignore',
                    'editor-editormodel-AI-SuggestionDegree-0':'  High School',
                    'editor-editormodel-AI-SuggestionDegree-1':'  Undergraduate',
                    'editor-editormodel-AI-SuggestionDegree-2':'  Current',
                    'editor-editormodel-AI-SuggestionDegree-3':'  Graduate',
                    'editor-editormodel-AI-SuggestionDegree-4':'  Doctoral',
                    'editor-editormodel-Rephrasing':'Rephrasing selected content',
                    'editor-editormodel-Refineing':'Refining selected content',
                    'editor-editormodel-copytext':'Text copied to clipboard!',
                    'editor-editormodel-rightLibrary':'Resources Library',
                    'editor-editormodel-rightLibraryRemove':'Remove',
                    'editor-editormodel-rightLibraryCite':'Cite',
                    'editor-editormodel-rightLibraryAdd':'Add',
                    'editor-editormodel-reorganize-replace':'Replace',
                    'editor-editormodel-reorganize-rewrite':'Rewrite',
                    'editor-editormodel-reorganize-loading':'Exploring how reorganization could improve your draft.',
                    'save-loading-text': 'saving...',
                    'save-completed-text': 'save completed',
                    'file-uploading-text': 'File Uploading',
                    'file-processing-text': 'File Processing',
                    'upload-draft-tip': 'Please upload a draft',
                    'ai-chat-placeholder': 'Message Doenba',
                    'import-draft-tip': 'Import an Existing Draft',
                    'ai-send-waiting-text': "I'm working on it ...",
                    'repeat-label': 'Label is ready taken',
                    'suggestion-all-ok': 'Impressive! <br/> You’ve made it shine!',
                    'toolbox-bold': 'Bold',
                    'toolbox-italic': 'Italic',
                    'toolbox-underline': 'Underline',
                    'toolbox-image': 'Figure',
                    'toolbox-table': 'Table',
                    'toolbox-math': 'Equation',
                    'toolbox-footnote': 'FootNote',
                    'toolbox-preview': '预览',
                    'import': '导入',
                    'outline-text': '默认大纲',
                    'outline-tooltip': 'Select an outline which you can modify or create your own as you write.',
                    'default': '默认大纲',
                    'extract': '提取大纲',
                    'authors': '作者信息',
                    'mini-nav-about-label': '关于',
                    'paper-edit-menu': '编辑',
                    'paper-view-menu': '查看',
                    'paper-del-menu': '删除',
                    'delete-paper-title': '删除文档',
                    'delete-paper-tip': '您确认要删除这篇文章吗？',
                    'modal-close': '关闭',
                    'cannot-insert-block-element': '无法插入块级元素',
                    'cannot-insert-block-element-description': '一级标题中不能插入块级元素，请将光标移至正文区域',
                    'editor-editormodel-AI-Generation':'自动生成',
                    'editor-editormodel-AI-Summary':'概述',
                    'editor-editormodel-AI-Abstract':'摘要',
                    'editor-editormodel-AI-Conclusion':'结论',
                    'pricing-plan-desc-1': '从您心怡的提纲开始',
                    'pricing-plan-desc-2': 'AI赋能内容编辑与排版',
                    'pricing-plan-desc-3': '内置问答聊天机器人',
                    'pricing-plan-desc-4': '文字处理器风格的界面',
                    'pricing-plan-desc-5': '便捷插入图表、表格、公式、交叉引用与参考文献',
                    'pricing-plan-desc-6': 'LaTeX 代码片段与实时章节预览',
                    'pricing-plan-desc-7': '一键导出到支持的 LaTeX模板',
                    'free-plan-title': '免费版',
                    'free-plan-subtitle': '阅读分析 + 审稿',
                    'free-plan-desc-1': '上传并阅读 PDF 与 CSV 文档',
                    'free-plan-desc-2': 'AI 驱动的文档分析，包括解析、摘要、数据处理与代码生成',
                    'free-plan-desc-3': '上传文档的互动任务问答聊天机器人',
                    'free-plan-desc-4': 'AI 驱动的精准阅读',
                    'free-plan-desc-5': 'AI 驱动的灵感建议，提升理解力',
                    'free-plan-desc-6': 'AI 驱动的论文审稿与反馈',
                    'pro-plan-subtitle': '编辑 + 阅读分析 + 审稿',
                    // FAQ entries
                    'faq-question-1': '什么是Doenba Edit？',
                    'faq-answer-1': 'Doenba Edit是由Librum Technologies Inc.开发的AI驱动的学术写作和编辑平台。它将实时编辑、LaTeX/Markdown/Word兼容性、版本跟踪和AI辅助润色整合到一个集成工作空间中，为学生、研究人员和教育工作者服务。',
                    'faq-question-2': '使用Doenba Edit需要安装什么吗？',
                    'faq-answer-2': '无需安装任何软件。Doenba Edit完全在浏览器中运行。只需注册并登录即可开始在线写作和编译。',
                    'faq-question-3': '我可以不注册就使用Doenba Edit吗？',
                    'faq-answer-3': '要创建或编辑文档，您需要一个账户。在Doenba主页上，选择"注册"来创建您的账户。',
                    'faq-question-4': 'Doenba Edit是免费的吗？付费计划是什么？',
                    'faq-answer-4': '我们为所有新用户提供**3天免费试用**。试用期结束后，您可以从三个付费计划中选择——周付、月付或年付。每个计划包含相同的功能集；唯一的区别是订阅时长。\n\n登录后，点击右上角的头像并选择"订阅"。从那里，您可以开始3天免费试用，之后选择最适合您需求的计划。',
                    'faq-question-5': '如何创建新文章？',
                    'faq-answer-5': '从仪表板点击"创建"。在下一页，输入您的文章标题，然后使用左侧面板构建大纲。您有三种创建方式：\n\n- **使用默认大纲** — 系统提供的基于主题的模板。\n- **从上传的文章中提取大纲**。\n- **从头创建大纲** 以完全自定义您的结构。\n\n大纲准备好后，您可以逐节开始写作您的文章。',
                    'faq-question-6': 'Doenba Edit中的保存是如何工作的？',
                    'faq-answer-6': '所有更改在您输入时**自动保存**。每次编辑都存储在云端并与您的账户关联。您可以随时下载PDF或LaTeX源文件。',
                    'faq-question-7': 'AI助手如何帮助我？',
                    'faq-answer-7': 'AI助手可以润色您的写作、按意思重写句子、建议结构、生成大纲、修复格式和检查引用。每个操作都通过Doenba的AI技术协调，以确保准确性和可追溯性。',
                    'faq-question-8': '如果我取消订阅会怎样？',
                    'faq-answer-8': '如果您取消订阅：\n\n- **您的数据是安全的**：您的所有工作和文章都会安全存储。\n- **访问暂停**：在重新订阅之前，您无法查看或编辑您的文章。\n- **轻松重新激活**：随时重新订阅即可立即恢复对您账户和保存内容的完全访问。',
                    'faq-question-9': '我的数据如何存储和保护？',
                    'faq-answer-9': '文档经过**加密**并安全存储在Librum云服务器上。数据传输使用**SSL加密**，私人项目只有授权用户才能访问。',
                    'faq-question-10': '如何恢复文章的先前版本？',
                    'faq-answer-10': '在您的文档中，转到右上角的"**版本历史**"以访问所有保存的版本。您可以预览、比较和恢复任何先前版本。',
                    'faq-question-11': '如何获得更多帮助或联系支持？',
                    'faq-answer-11': '访问**帮助中心/FAQ**页面，或观看我们的视频教程（位于文章编辑页面的左下角）。您也可以使用右侧的帮助中心向我们发送您的问题和联系信息。我们会通过电子邮件跟进支持。'
                }
            }
        }
    })
